module.exports = __webpack_public_path__ + "static/media/cultonLogo.c59f53dd.png";